import styled from 'styled-components'
import Icon from './Icon'
import {useEffect, useState} from 'react'
import {Left, Quantity, Right} from './Item'

function Children({ item, orderItems, addOrderItem, removeOrderItem, parentItem, index }) {
    const [orderItemQuantity, setOrderItemQuantity] = useState(0)
    const [freeAddonsAdded, setFreeAddonsAdded] = useState(0)

    useEffect(() => {
        if (!(parentItem.id in orderItems)) {
            setOrderItemQuantity(0)
            setFreeAddonsAdded(0)

            return;
        }

        if (!(orderItems[parentItem.id].children[index])) {
            setOrderItemQuantity(0)
            setFreeAddonsAdded(0)

            return;
        }

        let freeAddonsAdded = 0;
        Object.entries(orderItems[parentItem.id].children[index]).forEach(([key, value]) => {
            if (value.price == 0) {
                freeAddonsAdded += value.quantity;
            }
        })

        setFreeAddonsAdded(freeAddonsAdded)

        if (item.id in orderItems[parentItem.id].children[index]) {
            setOrderItemQuantity(orderItems[parentItem.id].children[index][item.id].quantity)

            return;
        }

        setOrderItemQuantity(0)

    }, [item.id, orderItems])


    const renderAdding = () => {
        const showPlus = (orderItemQuantity === 0 && freeAddonsAdded === 0) || item.price > 0;
        return <>
            {orderItemQuantity > 0 && <>
                <Icon type={'minus'} onClick={() => removeOrderItem(item, index)}/>
                <Quantity>{orderItemQuantity}</Quantity>
            </>}

            {showPlus && <Icon type={'plus'} onClick={() => addOrderItem(item, index)} />}
            {!showPlus && <Icon type={'plus'} disabled={true} />}
        </>
    }

    return (
        <Wrapper>
            <Left>
                <div>{item.title} <span>{item.price}€</span></div>
                <p>{item.description}</p>
            </Left>
            <Right>
                {renderAdding()}
            </Right>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
`;

export default Children;
